import React from 'react';
import { Factory, Wrench, MapPin, ShieldCheck, Users, Clock } from 'lucide-react';

const trustPoints = [
  { icon: Factory, value: '200+', label: 'Plant Installations Delivered' },
  { icon: Wrench, value: 'In-House', label: 'Design & Fabrication, Jaipur' },
  { icon: MapPin, value: 'PAN India', label: 'Installation & Service Network' },
  { icon: ShieldCheck, value: 'SS 304', label: 'Food-Grade Construction' },
  { icon: Users, value: '15+ Years', label: 'Engineering Experience' },
  { icon: Clock, value: '24 Hr', label: 'Enquiry Response Time' }
];

export const GoogleReviewsStrip = () => (
  <section className="py-12 bg-white border-y border-gray-100" data-testid="google-reviews-strip">
    <div className="container mx-auto px-4">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2 text-center">
        Why Plant Owners Choose Alden
      </h2>
      <p className="text-gray-600 text-center mb-10">
        Verifiable capability — not marketing claims
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4" data-testid="google-reviews-list">
        {trustPoints.map((t) => (
          <div
            key={t.label}
            className="bg-gray-50 border border-gray-200 rounded-xl p-5 text-center hover:border-alden-green transition-colors"
            data-testid="google-review-card"
          >
            <t.icon className="w-7 h-7 text-alden-green mx-auto mb-3" />
            <div className="text-xl font-bold text-gray-900">{t.value}</div>
            <div className="text-xs text-gray-600 mt-1">{t.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default GoogleReviewsStrip;
